var map = {
	"./default.png": 1006,
	"./down.png": 1007,
	"./empty.png": 1008,
	"./hide-navigation.png": 1009,
	"./left.png": 1010,
	"./logo_pieni.png": 1011,
	"./map-layer-button-3d-dark.png": 1012,
	"./map-layer-button-3d-light.png": 1013,
	"./map-layer-button-rounded-dark.png": 1014,
	"./map-layer-button-rounded-light.png": 1015,
	"./map-layer-button-sharp-dark.png": 1016,
	"./map-layer-button-sharp-light.png": 1017,
	"./marker.png": 1018,
	"./menu-3d-dark.png": 1019,
	"./menu-3d-light.png": 1020,
	"./menu-rounded-dark.png": 1021,
	"./menu-rounded-light.png": 1022,
	"./menu-sharp-dark.png": 1023,
	"./menu-sharp-light.png": 1024,
	"./mobile-my-location-dark.png": 1025,
	"./mobile-my-location-light.png": 1026,
	"./myplaces-draw-area-dark.png": 1027,
	"./myplaces-draw-area-light.png": 1028,
	"./myplaces-draw-line-dark.png": 1029,
	"./myplaces-draw-line-light.png": 1030,
	"./myplaces-draw-point-dark.png": 1031,
	"./myplaces-draw-point-light.png": 1032,
	"./oskari_icon.png": 1033,
	"./panbutton-sprites-3d-dark.png": 1034,
	"./panbutton-sprites-3d-light.png": 1035,
	"./panbutton-sprites-rounded-dark.png": 1036,
	"./panbutton-sprites-rounded-light.png": 1037,
	"./panbutton-sprites-sharp-dark.png": 1038,
	"./panbutton-sprites-sharp-light.png": 1039,
	"./pti_icon.png": 1040,
	"./right.png": 1041,
	"./root.png": 1042,
	"./search-tool-3d-dark_01.png": 1043,
	"./search-tool-3d-dark_02.png": 1044,
	"./search-tool-3d-dark_03.png": 1045,
	"./search-tool-3d-light_01.png": 1046,
	"./search-tool-3d-light_02.png": 1047,
	"./search-tool-3d-light_03.png": 1048,
	"./search-tool-rounded-dark_01.png": 1049,
	"./search-tool-rounded-dark_02.png": 1050,
	"./search-tool-rounded-dark_03.png": 1051,
	"./search-tool-rounded-light_01.png": 1052,
	"./search-tool-rounded-light_02.png": 1053,
	"./search-tool-rounded-light_03.png": 1054,
	"./search-tool-sharp-dark_01.png": 1055,
	"./search-tool-sharp-dark_02.png": 1056,
	"./search-tool-sharp-dark_03.png": 1057,
	"./search-tool-sharp-light_01.png": 1058,
	"./search-tool-sharp-light_02.png": 1059,
	"./search-tool-sharp-light_03.png": 1060,
	"./show-navigation.png": 1061,
	"./sprite.png": 1062,
	"./suomi25m_tm35fin.png": 1063,
	"./tool-history-back-dark.png": 1064,
	"./tool-history-back-light.png": 1065,
	"./tool-history-forward-dark.png": 1066,
	"./tool-history-forward-light.png": 1067,
	"./tool-measure-area-dark.png": 1068,
	"./tool-measure-area-light.png": 1069,
	"./tool-measure-line-dark.png": 1070,
	"./tool-measure-line-light.png": 1071,
	"./tool-zoombox-dark.png": 1072,
	"./tool-zoombox-light.png": 1073,
	"./up.png": 1074,
	"./world_dark.svg": 1075,
	"./world_light.svg": 1076,
	"./zoombar-3d-dark.png": 1077,
	"./zoombar-3d-light.png": 1078,
	"./zoombar-cursor-3d-dark.png": 1079,
	"./zoombar-cursor-3d-light.png": 1080,
	"./zoombar-cursor-rounded-dark.png": 1081,
	"./zoombar-cursor-rounded-light.png": 1082,
	"./zoombar-cursor-sharp-dark.png": 1083,
	"./zoombar-cursor-sharp-light.png": 1084,
	"./zoombar-rounded-dark.png": 1085,
	"./zoombar-rounded-light.png": 1086,
	"./zoombar-sharp-dark.png": 1087,
	"./zoombar-sharp-light.png": 1088,
	"./zoombar.png": 1089,
	"./zoombar_cursor.png": 1090,
	"./zoombar_minus-3d-dark.png": 1091,
	"./zoombar_minus-3d-light.png": 1092,
	"./zoombar_minus-patched.png": 1093,
	"./zoombar_minus-rounded-dark.png": 1094,
	"./zoombar_minus-rounded-light.png": 1095,
	"./zoombar_minus-sharp-dark.png": 1096,
	"./zoombar_minus-sharp-light.png": 1097,
	"./zoombar_minus.png": 1098,
	"./zoombar_minus_mobile.png": 1099,
	"./zoombar_plus-3d-dark.png": 1100,
	"./zoombar_plus-3d-light.png": 1101,
	"./zoombar_plus-rounded-dark.png": 1102,
	"./zoombar_plus-rounded-light.png": 1103,
	"./zoombar_plus-sharp-dark.png": 1104,
	"./zoombar_plus-sharp-light.png": 1105,
	"./zoombar_plus.png": 1106,
	"./zoombar_plus_mobile.png": 1107,
	"./zoombar_plus_patched.png": 1108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1005;